<template>
  <div class="orderDetail">
    <div class="item">
      Pages:<span>{{ showData.pages }}</span>
    </div>
    <div class="item">
      Assignment Type:<span>{{ showData.assignment_type_text }}</span>
    </div>
    <div class="item">
      Assignment Language:<span>{{ showData.assignment_language_text }}</span>
    </div>
    <div class="item">
      Assignment Detail:<span>{{ showData.assignment_details_text }}</span>
    </div>
    <div class="item">
      Education:<span>{{ showData.education_level_text }}</span>
    </div>
    <div class="item">
      Deadline:<span>{{ deadline }}</span>
    </div>
    <div class="item">
      Assignment Topic:<span>{{ showData.assignment_topic }}</span>
    </div>
    <div class="item">
      Number Of Sources:<span>{{ showData.number_of_sources }} sources required</span>
    </div>
    <div class="item">
      Citation Styles:<span>{{ showData.citation_styles_text }}</span>
    </div>
    <div class="item">
      Subject:<span>{{ showData.subject_text }}</span>
    </div>
    <div class="item">
      Instruction：
      <div class="concrete" v-dompurify-html="showData.instructions"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['showData'],
  name: 'order-detail',
  data: function () {
    return {};
  },
  computed: {
    deadline() {
      return new Date(this.showData.deadline * 1000).Format('yyyy-MM-dd hh:mm');
    },
  },
};
</script>

<style lang="scss" scoped>
.orderDetail {
  margin-top: 20px;
  .item {
    margin-top: 20px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9c9c9c;
    span {
      margin-left: 15px;
      color: #000000;
    }
    .concrete {
      margin-top: 20px;
      color: #000000;
      line-height: 22px;
    }
  }
}
</style>
